export default typeof window !== 'undefined' &&
  ('IntersectionObserver' in window ||
    'IntersectionObserverEntry' in window ||
    (window.IntersectionObserverEntry &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype));
